import React, {Component} from "react";

import ProjectRepository from "../data/ProjectRepository";
import Navbar from "../components/Navbar";
import ProjectList from "../components/ProjectList";
import ProjectDetails from "../components/ProjectDetails";
import PhaseList from "../components/PhaseList";
import PhaseModel from "../models/phase";
import PhaseRepository from "../data/PhaseRepository";

export default class ProjectsOverview extends Component {
    constructor(props) {
        super(props);

        this.state = {
            projects: [],
            selectedProject: 0,
            phases: [new PhaseModel(1, 'Testphase', 'TPA', 5)]
        };

        this.projectRepository = new ProjectRepository();
        this.phaseRepository = new PhaseRepository();
        this.loadProjects();
    }

    async loadProjects() {
        this.setState({'projects': await this.projectRepository.get()});
    }

    async loadPhases(projectId) {
        let phases = await this.phaseRepository.get(projectId);
        this.setState({'phases': phases});
    }

    async deletePhase(phaseId) {
        let success = await this.phaseRepository.delete(phaseId);

        if (!success) {
            alert('Phase kann nicht gelöscht werden.');
        }

        let phases = this.state.phases.filter(phase => phase.id !== phaseId);
        this.setState({phases: phases});
    }

    onDeletePhase = async (phaseId) => {
        await this.deletePhase(phaseId);
    };

    onSelectedProjectChanged = (id) => {
        this.setState({selectedProject: id});
        this.loadPhases(id);
    };

    getSelectedProject() {
        return this.state.projects.find(project => project.id === this.state.selectedProject);
    }
    
    getSelectedProjectName() {
        let project = this.getSelectedProject();
        if (project === undefined) {
            return '–';
        }
        return `${project.number} - ${project.name}`;
    }

    render() {
        return (
            <div className="app">
                <Navbar>
                    <span className="navbar-text text-white mr-3">Ausgewähltes Projekt: {this.getSelectedProjectName()}</span>
                </Navbar>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3">
                            <ProjectList projects={this.state.projects}
                                         onSelectedProjectChanged={this.onSelectedProjectChanged}
                                         selectedProject={this.state.selectedProject}/>
                            <button type="button" className="btn btn-primary mt-3" onClick={() => this.loadProjects()}>Neu
                                laden
                            </button>
                        </div>
                        <div className="col-lg-9">
                            <ProjectDetails model={this.getSelectedProject()}/>
                            <PhaseList phases={this.state.phases} onDeletePhase={this.onDeletePhase}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/ProjectsOverview.js